import React from "react";

import { MdmObject, useGetObjectsByProjectQuery } from "gql/generated/types";
import { Button } from "primereact/button";
import { useNavigate, useOutletContext } from "react-router-dom";
import { TableColumn } from "utils/types";
import ItemsTable from "../components/ItemsTable";

const Objects = () => {
  const projectId = useOutletContext<string>();
  const { data, loading } = useGetObjectsByProjectQuery({
    variables: { id: projectId },
    skip: !projectId,
  });
  const navigate = useNavigate();

  const objectInfoBtn = (rowData: MdmObject) => (
    <Button
      icon="pi pi-info-circle"
      className="p-button-rounded p-button-text h-1rem w-1rem p-2"
      onClick={() => navigate(`/objects/${rowData.id}`)}
    />
  );

  const columns: TableColumn<MdmObject>[] = [
    { field: "title", header: "Object Code", sortable: true, filter: true },
    {
      field: "address",
      header: "Address",
      body: rowData =>
        `${rowData.address?.city ?? ""} ${rowData.address?.street ?? ""} ${rowData.address?.houseNumber ?? ""}`,
      sortable: true,
      filter: true,
    },
    { field: "description", header: "Description" },
    { field: "tags", header: "Tags", body: rowData => rowData.tags.join(", ") },
    {
      header: "Actions",
      body: objectInfoBtn,
    },
  ];

  return (
    <div className="card">
      <ItemsTable
        columns={columns}
        data={data?.mdmObjectsByProjectId as MdmObject[]}
        onToolbarBtnClick={() => navigate("/objects/new")}
        searchFields={["title", "address", "tags"]}
        toolbarBtnLabel="Add Object"
        isLoading={loading}
      />
    </div>
  );
};

export default Objects;
